<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Patient's Previous Records",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Patient's Previous Records",
            items: [
               {
                  text: "Patient's Previous Records",
                  active: true,
               },                   
            ],

           prescriptions: [],
            prescriptions_inputs: [
                  {value: null, preview_image: null, image: null}
            ],
            prescriptions_images: [],
            prescriptions_image_id: [],

            reports: [],
            reports_inputs: [
               {value: null, preview_image: null, image: null}
            ],
            reports_images: [],
            reports_image_id: [],
            
            errors: {},
            token: '',

            prescription: {
               doctor_name: '',
               notes: '',
               patient_id: '',
            },

            report: {
               notes: '',
               patient_id: '',
            },
            lab_reports: [],

            view_prescription: {},
            view_report: {},
            view_record: {},
            view_lab_report: {},


            health_records: [],

            digital: '',
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchPrescriptions();
         this.fetchHealthRecords();
         this.fetchReports();
         this.fetchLabReports();
      },

      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         fetchPrescriptions() {

            this.getToken();
            // let url = "clinic/patient_previous_prescriptions?patient_id="  + 51;
            let url = "clinic/patient_previous_prescriptions?patient_id="  + this.$route.params.id;

            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.prescriptions = responseData.prescriptions;
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 
         addPrescription() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/add_patient_prescription";  

       
            let formData = new FormData();
            // formData.append("patient_id", 51); 
            formData.append("patient_id", this.$route.params.id); 
            formData.append("doctor_name", this.prescription.doctor_name); 
            formData.append("notes", this.prescription.notes); 

            for(var k = 0; k < this.prescriptions_images.length; k++) {
               let file = this.prescriptions_images[k];
               formData.append('prescriptions[' + k + ']', file);
            }
           
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal('prescription-modal');
                  this.fetchPrescriptions();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
         clearForm() {
            this.prescription.doctor_name = '';
            this.prescription.notes = '';
            this.prescription.patient_id = '';

            this.prescriptions_inputs = [
                  {value: null, preview_image: null, image: null}
            ];
            this.prescriptions_images =  [];
            this.prescriptions_image_id = [];

            this.report.notes = '';
            this.report.patient_id = '';

            this.reports_inputs = [
                  {value: null, preview_image: null, image: null}
            ];
            this.reports_images =  [];
            this.reports_image_id = [];

            this.errors = {};

         },
         fetchHealthRecords() {

            this.getToken();
            let url = "clinic/patient_health_records?patient_id="  + this.$route.params.id;

            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.health_records = responseData.consultations;
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 
         fetchReports() {

            this.getToken();
            let url = "clinic/patient_medical_records?patient_id="  + this.$route.params.id;

            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.reports = responseData.medical_records;
                 
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         addReport() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/add_patient_medical_record";  

       
            let formData = new FormData();
            formData.append("patient_id", this.$route.params.id); 
            formData.append("notes", this.report.notes); 

            for(var k = 0; k < this.reports_images.length; k++) {
               let file = this.reports_images[k];
               formData.append('medicalrecords[' + k + ']', file);
            }
           
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal('report-modal');
                  this.fetchReports();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         fetchLabReports() {

         this.getToken();
         let url = "clinic/patient_lab_records?patient_id="  + this.$route.params.id;

         this.loading = true;

         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               if(responseData){
               this.lab_reports = responseData.lab_records;
               }
            
            
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));
         },

         prescriptions_add() {
               this.prescriptions_inputs.push({ value: null });
            },

            prescriptions_remove(index) {
               this.prescriptions_inputs.splice(index, 1);
               this.prescriptions_images.splice(index, 1);
            }, 

            prescriptions_setFile(e, index) {
               this.prescriptions_images.push(e.target.files[0]);
               this.prescriptions_inputs[index].image = e.target.files[0];
            this.prescriptions_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         prescriptions_deleteImage(id, index) {
            this.prescriptions.splice(index, 1);
            this.prescriptions_image_id.push(id);
         },


         reports_add() {
               this.reports_inputs.push({ value: null });
            },

            reports_remove(index) {
               this.reports_inputs.splice(index, 1);
               this.reports_images.splice(index, 1);
            }, 

            reports_setFile(e, index) {
               this.reports_images.push(e.target.files[0]);
               this.reports_inputs[index].image = e.target.files[0];
            this.reports_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         reports_deleteImage(id, index) {
            this.reports.splice(index, 1);
            this.reports_image_id.push(id);
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         viewPrescription(prescription) {
            this.view_prescription = prescription;
            this.showModal('view-prescription-modal');
         },
         viewRecord(record) {
            this.view_record = record;
            this.showModal('view-record-modal');
         },

         viewReport(report) {
            this.view_report = report;
            this.showModal('view-report-modal');
         },

         viewLabReport(lreport) {
            this.view_lab_report = lreport;
            this.showModal('view-lab-report-modal');
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        <!-- <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Previous Prescriptions Added By Patient                        
                        <b-button v-b-modal.prescription-modal variant="primary" class="btn-sm float-end">Add Prescription</b-button>
                     </h4>
                     <form>
                           
                        <b-row v-if="prescriptions.length" class="mt-5">
                           <b-col md="3" class="mb-3" v-for="(prescription) in prescriptions" :key="prescription.id">
                              <div class="card p-3 text-center">
                                 <p class="font-size-14 mb-0">{{prescription.prescription_date}}</p>
                                 <h5>Dr. {{prescription.doctor_name}}</h5>
                                 <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewPrescription(prescription)">View</b-button> 
                              </div>                                 
                           </b-col>
                        </b-row>

                        <b-row v-else>
                           <b-col md="12">
                              <p>No prescriptions added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card>

                 
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Previous Records Added By Medicino Doctors                    
                     </h4>
                     <form>
                        <b-row v-if="health_records.length" class="mt-5">
                           <b-col md="3" class="mb-3" v-for="(record, index) in health_records" :key="index">
                              <div class="card p-3 text-center">
                                 <p class="font-size-14 mb-0">{{record.booking_date +  " " + record.consultation_start | formatDateTime}}</p>
                                 <router-link :to="{ name: 'consultations.details', params: {id: record.id} }" class=""><p class="font-size-12 mb-0">Booking ID: {{record.id}}</p></router-link>
                                 
                                 <h5>Dr. {{record.doctor_name}}</h5>
                                 <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewRecord(record)">View</b-button> 
                              </div>                                 
                           </b-col>
                        </b-row>

                        <b-row v-else>
                           <b-col md="12">
                              <p>No prescriptions added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card>

                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Medical Reports                        
                        <b-button v-b-modal.report-modal variant="primary" class="btn-sm float-end">Add Report</b-button>
                     </h4>

                     <form>                                
                        <b-row v-if="reports.length" class="mt-5">
                           <b-col md="3" class="mb-3" v-for="(mreport) in reports" :key="mreport.id">
                              <div class="card p-3 text-center">
                                 <p class="mb-0">{{mreport.created_at | formatDateTime}}</p>
                                 <p class="font-size-14 mb-0">{{mreport.notes | excerpt(25)}}</p>
                                 
                                 <!-- <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewReport(mreport)">View</b-button>  -->
                                 <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewReport(mreport)">View</b-button> 
                              </div>                                 
                           </b-col>
                        </b-row>

                        <b-row v-else>
                           <b-col md="12">
                              <p>No reports added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card>

                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Lab Reports                        
                        <!--<b-button v-b-modal.report-modal variant="primary" class="btn-sm float-end">Add Report</b-button>-->
                     </h4>

                     <form>       

                        <b-row v-if="lab_reports.length" class="mt-5">
                           <b-col md="3" class="mb-3" v-for="(lreport) in lab_reports" :key="lreport.id">
                              <div class="card p-3 text-center">
                                 <p class="mb-0">{{lreport.created_at | formatDateTime}}</p>
                                 <!-- <p class="font-size-14 mb-0">{{lreport.notes | excerpt(25)}}</p> -->
                                 
                                 <!-- <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewLabReport(mreport)">View</b-button>  -->
                                 <b-button variant="outline-primary" class="btn mt-2 me-1 btn-sm" @click="viewLabReport(lreport)">View</b-button> 
                              </div>                                 
                           </b-col>
                        </b-row>
                        <b-row v-else>
                           <b-col md="12">
                              <p>No reports added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card>

                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Prescriptions                        
                        <b-button v-b-modal.prescription-modal variant="primary" class="btn-sm float-end">Add Report</b-button>
                     </h4>

                     <form>                                 
                        <b-row>
                           <b-col md="3" class="mb-3 text-center d-flex" v-for="(img, index) in reports" :key="img.id">
                              <div class="file-wrapper">
                                 <a href="#" target="_blank">
                                    <i class="fas fa-file-alt me-2"></i> 
                                    <p>Medical Report1</p></a>
                                    
                                 <b-button variant="outline-danger" class="btn mt-2 me-1 btn-sm" @click="reports_deleteImage(img.id, index)">Delete</b-button> 
                              </div>   
                           </b-col>
                        </b-row>
                     </form>
                  </b-card> -->


                  <!---- modal starts ---->
                  <b-modal ref="prescription-modal" id="prescription-modal" title="Add Prescription" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addPrescription()">
                     

                        <b-col md="12" class="form-group">
                           <label class="control-label">Doctor Name <span class="text-danger">*</span></label>
                           <b-input-group size="sm" prepend="Dr.">
                              <input type="text" class="form-control" v-model="prescription.doctor_name" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_name) }">
                              <div v-for="(val, index) in errors.doctor_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>

                           
                        </b-col>

                        <b-col md="12" class="form-group">
                           <label class="control-label">Notes <span class="text-danger">*</span></label>
                           <textarea class="form-control" v-model="prescription.notes" v-bind:class="{ 'is-invalid': Boolean(errors.notes) }"></textarea>

                           <div v-for="(val, index) in errors.notes" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <div class="form-group col-12 p-0">
                           <label class="control-label">Prescriptions <span class="text-danger">*</span></label>
                           <div class="form-control border-0" v-bind:class="{ 'is-invalid': Boolean(errors.prescriptions) }">

                              <b-row v-for="(input, index) in prescriptions_inputs" :key="index" class="mb-2">    
                                 <b-col md="12" class="form-group d-flex p-0">
                                    <div class="w-90">
                                       <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="prescriptions_setFile($event, index)"></b-form-file>
                                    </div>

                                    <span class="ms-1 mt-2">
                                       <i class="fas fa-minus-circle text-danger" @click="prescriptions_remove(index)" v-show="index || ( !index && prescriptions_inputs.length > 1)"></i>
                                       <i class="fas fa-plus-circle text-success" @click="prescriptions_add()" v-show="index == prescriptions_inputs.length-1"></i>
                                    </span>
                                 </b-col>
                                 
                              </b-row>

                           </div>

                           <div v-for="(val, index) in errors.prescriptions" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </div>
                       
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('prescription-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                  <!---- modal starts ---->
                  <b-modal ref="report-modal" id="report-modal" title="Add Report" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addReport()">
                        <b-col md="12" class="form-group">
                           <label class="control-label">Notes <span class="text-danger">*</span></label>
                           <textarea class="form-control" v-model="report.notes" v-bind:class="{ 'is-invalid': Boolean(errors.notes) }"></textarea>

                           <div v-for="(val, index) in errors.notes" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <div class="form-group col-12 p-0">
                           <label class="control-label">Reports <span class="text-danger">*</span></label>
                           <div class="form-control border-0" v-bind:class="{ 'is-invalid': Boolean(errors.medicalrecords) }">

                              <b-row v-for="(input, index) in reports_inputs" :key="index" class="mb-2">    
                                 <b-col md="12" class="form-group d-flex p-0">
                                    <div class="w-90">
                                       <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="reports_setFile($event, index)"></b-form-file>
                                    </div>

                                    <span class="ms-1 mt-2">
                                       <i class="fas fa-minus-circle text-danger" @click="reports_remove(index)" v-show="index || ( !index && reports_inputs.length > 1)"></i>
                                       <i class="fas fa-plus-circle text-success" @click="reports_add()" v-show="index == reports_inputs.length-1"></i>
                                    </span>
                                 </b-col>
                                 
                              </b-row>

                           </div>

                           <div v-for="(val, index) in errors.medicalrecords" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </div>
                        
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('report-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                   <!---- modal starts ---->
                  <b-modal ref="view-prescription-modal" id="view-prescription-modal" title="View Prescription" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <p class="font-size-14 mb-0">{{view_prescription.prescription_date}}</p>
                           <h5>Dr. {{view_prescription.doctor_name}}</h5>

                           <h4 class="mt-3 font-size-15">Notes:</h4>
                           <p>{{view_prescription.notes}}</p>

                           <div class="prescription-images">
                              <ul>
                                 <li  v-for="(img) in view_prescription.images" :key="img.id">
                                    <a :href="$image_url + img.image" target="_blank">
                                       <div class="file-pdf" v-if="img.type==2"> 
                                          <img class="" src="@/assets/images/prescription.jpg" alt="PDF" >
                                       </div>
                                       <div class="file-img" v-if="img.type==1"  v-bind:style="{ 'background-image': 'url(' + $image_url + img.image + ')' }">
                                          
                                       </div>   
                                    </a> 
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-prescription-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->

                  <!---- modal starts ---->
                  <b-modal ref="view-record-modal" id="view-record-modal" title="View Record" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <p class="font-size-14 mb-0">{{view_record.booking_date +  " " + view_record.consultation_start | formatDateTime}}</p>
                           <h5>Dr. {{view_record.doctor_name}}</h5>

                           <h4 class="mt-3 font-size-15">Notes:</h4>
                           <p>{{view_record.notes}}</p>

                           <div class="prescription-images">
                              <ul>
                                 <li  v-for="(img) in view_record.prescriptions" :key="img.id">
                                    <a :href="$image_url + img.prescription_url" target="_blank" v-if="img.prescription_type==1 || img.prescription_type==2">
                                       <div class="file-pdf" v-if="img.prescription_type==2"> 
                                          <img class="" src="" alt="PDF" >
                                       </div>
                                       <div class="file-img" v-if="img.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + $image_url + img.prescription_url + ')' }">
                                       </div> 
                                    </a> 
                                    <a href="#" @click.prevent="viewDigital(img.digital_prescription)">
                                       <div class="file-pdf" v-if="img.prescription_type==3"> 
                                          <img class="" src="" alt="PDF" >
                                       </div>
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-record-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->

                  <!---- modal starts ---->
                  <b-modal ref="view-report-modal" id="view-report-modal" title="View Medical Report" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <p class="font-size-14 mb-0">{{view_report.created_at | formatDateTime}}</p>
                           
                           <h4 class="mt-3 font-size-15">Notes:</h4>
                           <p>{{view_report.notes}}</p>

                           <div class="prescription-images">
                              <ul>
                                 <li  v-for="(img) in view_report.prescription_url" :key="img.id">                                    

                                    <a :href="$image_url + img.prescription_url" target="_blank">
                                       <div class="file-pdf" v-if="img.prescription_type==2"> 
                                          <img class="" src="" alt="PDF" >
                                       </div>
                                       <div class="file-img" v-if="img.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + $image_url + img.prescription_url + ')' }">
                                       </div>   
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-report-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->

                  <b-modal ref="view-lab-report-modal" id="view-lab-report-modal" title="View Lab Report" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <p class="font-size-14 mb-0">{{view_lab_report.created_at | formatDateTime}}</p>


                           <div class="prescription-images">
                              <ul>
                                 <li  v-for="(img) in view_lab_report.prescription_url" :key="img.id">                                    

                                    <a :href="$image_url + img.prescription_url" target="_blank">
                                       <div class="file-pdf" > 
                                          <img class="" src="" alt="PDF" >
                                       </div>
                                       <div class="file-img" v-bind:style="{ 'background-image': 'url(' + $image_url + img.prescription_url + ')' }">
                                       </div>   
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-lab-report-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
